








































































import {
  apiBasicZoneLocationGetDistrictList,
  ApiBasicZoneLocationGetDistrictListResponse,
  apiMerchantStoreQueryWriteOffStoreList,
  ApiMerchantStoreQueryWriteOffStoreListResponse,
} from '@/api'
import { computed, ref } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import {
  defineClassComponent,
  useApiPlus,
  useHandler,
  useQuery,
} from '@/hooks'
import { Merge, RequiredDeep } from 'vtils/types'
import { navigateBack } from '@/router'
import { openMap, showDialog, Track } from '@/utils'
import { TreeData } from 'vtils'
import { useBus } from './use_bus'

type DistrictItem = Merge<
  ApiBasicZoneLocationGetDistrictListResponse['list'][0],
  {
    childList: DistrictItem[]
    children: DistrictItem[]
  }
>

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '核销门店选择',
        }))
      }

      loading = computed(() => this.apiData.loading)

      query = useQuery<{
        // 商户 ID
        id: string
      }>()

      apiData = useApiPlus(
        {
          x: () => Promise.resolve(),
          divisionData: () =>
            apiBasicZoneLocationGetDistrictList({}).then(res => {
              const tree = new TreeData<DistrictItem>(res.list as any, {
                childrenPropName: 'childList',
              })
              tree.traverse(_ => {
                if (_.depth === 0 && !_.node.name.includes('贵州')) {
                  _.removeNode()
                }
              })
              tree.traverse(_ => {
                if (_.depth === 0 || _.depth === 1) {
                  // @ts-ignore
                  _.node.childList.unshift({
                    simpleName: !_.node.code ? '' : '全部',
                    code: '',
                    childList: [],
                  })
                }
              })
              tree.setDepth(2).setNodeProps({
                text: _ => _.node.simpleName,
                children: _ => _.node.childList,
              })
              return tree.export()
            }),
        },
        {
          onChange: ({ first }) => {
            if (first) {
              showDialog({
                title: '温馨提示',
                message:
                  '该商品下单完成后将无法修改核销点，请您慎重选择自提点。',
                noCancel: true,
                confirmText: '确定',
              })
            }
          },
        },
      )

      divisionData = computed(() => this.apiData.data.divisionData)

      showDivisionPicker = ref(false)

      division = ref({
        provinceName: '贵州省',
        cityName: '全部',
        districtName: '',
        provinceCode: '520000',
        cityCode: '',
        districtCode: '',
      })
      divisionDisplay = computed(() =>
        [
          this.division.value.provinceName,
          this.division.value.cityName,

          this.division.value.districtName,
        ]
          .filter(Boolean)
          .join('·'),
      )
      keyword = ref('')
      keywordTemp = ref('')

      handleLoad = ({ pageNumber }: any) => {
        return apiMerchantStoreQueryWriteOffStoreList({
          provinceCode: this.division.value.provinceCode,
          cityCode: this.division.value.cityCode,
          countyCode: this.division.value.districtCode,
          pageIndex: pageNumber,
          pageSize: 10,
          keyWord: this.keyword.value,
          refMerchantId: this.query.id,
        })
      }

      handleServiceClick = useHandler<
        '区划' | '区划选择' | '搜索' | '选择' | '导航' | '电话'
      >({
        区划: () => {
          this.showDivisionPicker.value = true
        },
        区划选择: ([provinceIndex, cityIndex, countyIndex]: number[]) => {
          const provinceName =
            this.divisionData.value[provinceIndex].simpleName
          const cityName =
            this.divisionData.value[provinceIndex].children[cityIndex]
              .simpleName
          const districtName =
            this.divisionData.value[provinceIndex].children[cityIndex]
              .children[countyIndex].simpleName
          const provinceCode = this.divisionData.value[provinceIndex].code
          const cityCode =
            this.divisionData.value[provinceIndex].children[cityIndex].code
          const districtCode =
            this.divisionData.value[provinceIndex].children[cityIndex]
              .children[countyIndex].code
          this.division.value = {
            provinceName,
            cityName,
            districtName,
            provinceCode,
            cityCode,
            districtCode,
          }
          this.showDivisionPicker.value = false
        },
        搜索: () => {
          this.keyword.value = this.keywordTemp.value
        },
        选择: (
          item: RequiredDeep<ApiMerchantStoreQueryWriteOffStoreListResponse>['list'][0],
        ) => {
          useBus.emit('select', item)
          navigateBack()
        },
        导航: (
          item: RequiredDeep<ApiMerchantStoreQueryWriteOffStoreListResponse>['list'][0],
        ) => {
          openMap({
            name: item.storeName,
            longitude: +item.longitude,
            latitude: +item.latitude,
          })
        },
        电话: (
          item: RequiredDeep<ApiMerchantStoreQueryWriteOffStoreListResponse>['list'][0],
        ) => {
          dcb.makePhoneCall({
            phoneNumber: item.contactPhone,
          })
        },
      })
    },
)
